<template>
  <div class="links">
    <div class="container">
      <ul class="list">
        <li class="list__item">
          <router-link class="list__link" to="/info/about">{{
            $t("ABOUT_APPDB")
          }}</router-link>
        </li>
        <li class="list__item">
          <router-link class="list__link" to="/info/tos">{{
            $t("TERMS OF SERVICE")
          }}</router-link>
        </li>
        <li class="list__item">
          <router-link class="list__link" to="/info/privacy">
            {{ $t("PRIVACY POLICY") }}
          </router-link>
        </li>
        <li class="list__item">
          <router-link class="list__link" to="/info/api">{{
            $t("APIS")
          }}</router-link>
        </li>
        <li class="list__item">
          <a
            class="list__link"
            target="_blank"
            :href="`https://status.dbservices.to/#${theme}`"
            >{{ $t("SYSTEM STATUS") }}</a
          >
        </li>
        <li class="list__item">
          <a
            class="list__link"
            target="_blank"
            href="https://a.appdb.to/acp.php"
            >{{ $t("STAFF MEMBER AREA") }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['theme']),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.links {
  background-color: var(--footer-bottom-bg);
  padding: 25px 0;

  @include notebook {
    padding: 10px 0;
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &__item {
    margin-right: 40px;

    &:last-child {
      margin-right: 0;
    }

    @include notebook {
      margin-right: 0;
    }
  }

  &__link {
    color: $footer-link-color;
    font-size: 12px;
    font-weight: 500;

    @include notebook {
      line-height: 22px;
      padding: 0 10px;
    }
  }
}
</style>
